export const COOPERATIONS_STATUS = {
  ACTIVE: 'ACTIVE',
  FINISHED: 'FINISHED',
  NOTICE: 'NOTICE',
  DEBT_RECOVERY: 'DEBT_RECOVERY',
};
